import type { ExternalTransactionSource } from '@realadvisor/common-types';

type PropertyContext = {
  countryCode: string | null | undefined;
  lat: number | null | undefined;
  lng: number | null | undefined;
};

type ExternalTransactionSourceAdapter = {
  source: ExternalTransactionSource;
  isEligible: (property: PropertyContext) => boolean;
};

const DVF_FR_SOURCE_ADAPTER: ExternalTransactionSourceAdapter = {
  source: 'dvf_fr',
  isEligible: property =>
    property.countryCode === 'FR' &&
    property.lat != null &&
    property.lng != null,
};

const EXTERNAL_TRANSACTION_SOURCE_ADAPTERS = [DVF_FR_SOURCE_ADAPTER] as const;

export const getEligibleExternalTransactionSource = (
  property: PropertyContext,
) =>
  EXTERNAL_TRANSACTION_SOURCE_ADAPTERS.find(adapter =>
    adapter.isEligible(property),
  ) ?? null;
